import React from 'react';
import './TabNav.scss'
import classNames from 'classnames';
import { Link, NavLink } from 'react-router-dom';
import useHideOnScroll from '../../../hooks/useHideOnScroll';

export const TAB_NAV_VARIANTS = {
    SUBNAV : 'subnav'
}

export const TabNavItem = ({children, onlyIcon, active=false, isNavLink, isLink, ...props}) => {
    const Tag = (isNavLink || isLink) ? (isNavLink ? NavLink : Link) : 'button';
    return <Tag className={classNames("tab-nav-item", {active, onlyIcon})} {...props}>{children}</Tag>
}

export const TabTitle = ({children}) => {
    return (
        <div className="tab-title">
            {children}
        </div>
    );
};

const TabNav = ({sticky=false, children, variant, isNav=false, autoHide=false, className, ...props}) => {
    const hidden = useHideOnScroll();
    const Tag = isNav ? 'nav' : 'div';
    return (
        <Tag className={classNames('tab-nav', className, variant, {sticky, hidden : (autoHide ? hidden : false)})} {...props}>
            {children}
        </Tag>
    );
};

export default React.memo(TabNav);